module.exports = "/_next/static/images/Dewalt-fb7dc7f0914dc8c670d58a544087539e.png";